import { VITE_REACT_APP_API_GRAPHQL } from "../../constants/variables";
import { AuthSessionState } from "../../auth/oauth/AuthSession";
import oAuthClient from "../../auth/oauth/instance";
import { LogDocument, LogTransportInterface } from "./LoggerTypes";

const base = VITE_REACT_APP_API_GRAPHQL.replace("/graphql", "");

export class NetworkTransport implements LogTransportInterface {
  private readonly route = `${base}/logs`;

  async logDocument(doc: LogDocument): Promise<boolean> {
    const session = await oAuthClient.getSession();
    if (session.state !== AuthSessionState.AUTHENTICATED) {
      return false;
    }
    const token = session.accessToken;
    try {
      const stringData = JSON.stringify({
        ...doc,
        level: doc.level.toString(),
      });
      const response = await fetch(this.route, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: stringData,
      });
      if (!response.ok) {
        return false;
      }
      const res = await response.json();
      if (res.message) {
        return true;
      }
    } catch (_error) {
      return false;
    }
    return false;
  }
}
